export default function (/**@type {ApisauceInstance} */ api) {
  const getAllCustomers = (paging) => api.get(`Customer`, paging);
  const getCustomerWithId = (id) => api.get(`Customer/${id}`);
  const addCustomer = (payload) => api.post(`Customer`, payload);
  const editCustomer = ({ payload, id }) => api.put(`Customer/${id}`, payload);
  const deleteCustomer = (id) => api.delete(`Customer/${id}`);

  return {
    Customers: {
      getAllCustomers,
      getCustomerWithId,
      addCustomer,
      editCustomer,
      deleteCustomer,
    },
  };
}
